import { browserType } from ".";

export const TurnoInIndiaData = [
  {
    title: "Turno announces new fundraise of $6 million",
    altText: "Turno EV-fund-raise",
    description:
      " We are extremely excited to announce that Turno has raised $6 million in an extension of our Series A round. The round saw the participation of British International Investment along with existing investors-Quona Capital, Stellaris Ventures, and B Capital.",
    date: "May 29, 2024",
    link: "",
    image:`${process.env.NEXT_PUBLIC_CDN_LINK}AboutUs/fold+3/press_img4.webp`,
  },
  {
    title: "The ‘Orchestrator’ Of Commercial EV Segment",
    altText: "Turno EV-fund-raise",
    description:
      "Turno Bags $3.1 Mn In Seed Funding: The funding round was led by Stellaris Venture Partners, with participation from Avaana Capital.",
    date: "June 29, 2022",
    link: "",
    image:
      browserType === " Chrome"
        ? `${process.env.NEXT_PUBLIC_CDN_LINK}AboutUs/fold+3/press_img1.avif`
        : `${process.env.NEXT_PUBLIC_CDN_LINK}AboutUs/fold+3/press_img1.jpg`,
  },
  {
    title: "Turno to expand across states with new funds",
    altText: "Turno EV-fund-raise",
    description:
      "Commercial EV startup Turno plans to use the capital to expand across Maharashtra, the NCR, Tamil Nadu, and Gujarat, among others. The funding round was led by Stellaris Venture Partners from Avaana Capital.",
    date: "June 29, 2022",
    link: "",
    image:
      browserType === " Chrome"
        ? `${process.env.NEXT_PUBLIC_CDN_LINK}AboutUs/fold+3/press_img2.avif`
        : `${process.env.NEXT_PUBLIC_CDN_LINK}AboutUs/fold+3/press_img2.jpg`,
  },
  {
    title: "Startup Turno raises $3.1m funding from Stellaris",
    altText: "Turno EV-fund-raise",
    description:
      "The round saw participation from several angel investors including Vipul Parekh (co-founder, Bigbasket) Lizzie Chapman and Others.",
    date: "June 29, 2022",
    link: "",
    image:
      browserType === " Chrome"
        ? `${process.env.NEXT_PUBLIC_CDN_LINK}AboutUs/fold+3/press_img3.avif`
        : `${process.env.NEXT_PUBLIC_CDN_LINK}AboutUs/fold+3/press_img1.jpg`,
  },
];
